<template>
  <slot v-if="!isHideContent"></slot>
</template>

<script setup lang="ts">
import * as Sentry from '@sentry/vue';
import axios from 'axios';
import { inject, onErrorCaptured, ref, watch, nextTick } from 'vue';
import { GlobalStoreKey } from '@/composables/useGlobalStore';
import { useToast } from '@/composables/useToast';

const globalStoreInjection = inject(GlobalStoreKey);
if (!globalStoreInjection) throw new Error(`${GlobalStoreKey} NOT PROVIDE`);
const { startLoading } = globalStoreInjection;

const { activateToast } = useToast();

// propsでも使えるように設定
type Props = {
  errors?: any[];
};
const props = withDefaults(defineProps<Props>(), {
  errors: () => [],
});

const __DEBUG__ = import.meta.env.MODE !== 'prod';

const isHideContent = ref<boolean>(false);

// propsの値が変わったらデータを更新
watch(
  props.errors,
  (errors) => {
    if (errors.length) {
      _errorAction(errors);
      isHideContent.value = true;
      startLoading();
    }
  },
  { immediate: false }
);

onErrorCaptured((_error) => {
  // キャンセルされたリクエストはエラーとして扱わない
  if (axios.isCancel(_error)) {
    return false;
  }

  _errorAction([_error]);
  return false;
});

// onErrorCapturedでキャッチできないエラーをキャッチ
window.onerror = async (errorMessage, _url, _lineNumber, _columnNumber, error) => {
  if (error instanceof Error && error.message !== 'ResizeObserver loop limit exceeded') {
    _errorAction([error]);
    isHideContent.value = true;
    await nextTick();
    startLoading();
  }
};

const _errorAction = async (errors: Error[]) => {
  // HACK:トーストのレンダリングを待つ
  await nextTick();
  activateToast('error', 'systemError');
  errors.forEach((error) => {
    Sentry.captureException(error);

    // デバッグ環境ではconsoleする
    if (__DEBUG__) {
      if (axios.isAxiosError(error)) {
        const res = error.response;
        console.error(`[${res?.config?.method?.toUpperCase()}] ${res?.config?.url} => ${res?.status}`, error?.message);
      } else if (error instanceof Error) {
        console.error(error);
      } else {
        console.error(error);
      }
    }
  });
};
</script>
